import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Dashboard() {
  const { user, isAdmin, isLecturer, isStudent } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;

    // Redirect based on primary role (priority: admin > lecturer > student)
    if (isAdmin()) {
      navigate('/dashboard/admin/dashboard', { replace: true });
    } else if (isLecturer()) {
      navigate('/dashboard/lecturer/dashboard', { replace: true });
    } else if (isStudent()) {
      navigate('/dashboard/student/dashboard', { replace: true });
    }
  }, [user, navigate, isAdmin, isLecturer, isStudent]);

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
}
